import { axiosSelfDefined } from "../service/axios";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";

const useAxiosPrivateSelfDefined = () => {
    const refresh = useRefreshToken();
    const {auth} = useAuth();
    useEffect(() => {
        const requestIntercept = axiosSelfDefined.interceptors.request.use(
            config => {
                if (!config.headers["Authorization"]) {
                    config.headers["Authorization"] = `Bearer ${auth?.token}`
                }
                return config;
            }, (error) => Promise.reject(error)
        )
        const responseIntercept = axiosSelfDefined.interceptors.response.use(
            response => response,
            async (error) => {
                const preRequest = error?.config;
                if (error?.response?.status === 401 && !preRequest?.sent) {
                    preRequest.sent = true;
                    const newAccessToken = await refresh();
                    preRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
                    return axiosSelfDefined(preRequest);
                }
                return Promise.reject(error);
            }
        )
        return () => {
            axiosSelfDefined.interceptors.request.eject(requestIntercept);
            axiosSelfDefined.interceptors.response.eject(responseIntercept);
        }
    }, [auth, refresh]);

    return axiosSelfDefined;
}

export default useAxiosPrivateSelfDefined;